import { IDonation, IDonationPriceRange } from '~domain/entities/Donation/IDonation';
import { ISDProduct, ISDProductSku } from '~api/ProductAPI/IProductAPIs';

const reduceToPrices = (acc: IDonationPriceRange[], sku: ISDProductSku) => [
    ...acc,
    { price: sku.prices[0].price, skuId: sku.perlgem.SKU_BASE_ID.toString() }
];

export const mapDonations = (donation: ISDProduct, cmsOverrideDescription?: string): IDonation => ({
    id: donation.productId,
    imageUrl: donation.media.small[0].src,
    name: donation.displayName,
    description: cmsOverrideDescription ?? donation.description,
    prices: donation.initialSkus.reduce(reduceToPrices, []).sort((a, b) => a.price - b.price)
});
